import { Component, ElementRef, OnInit, ViewChild, Inject, ViewEncapsulation, Input, ViewContainerRef, AfterViewInit, Renderer2 } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Grade, PartyContactMechanisms, School, SCHOOL_STATUS } from 'src/app/model/school.model';
import { CONTACT_PERSON, EMAIL, PartyRoleTypes, POSTAL_ADDRESSES, TELEPHONE_NUMBERS } from 'src/app/model/school.model';
import * as moment from 'moment';
import { PARTYROLE } from 'src/app/model/region.model';
import { formatDate } from '@angular/common';
import { ShortDateTime } from 'src/app/pipes/short-date-time';
import { MatDialog } from '@angular/material/dialog';
import { EditSchoolComponent } from 'src/app/component/school/edit-school/edit-school.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Region } from '../../../model/region.model';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { UserProfileService } from '../../user-profile/service/user-profile.service';
import { User } from '../../auth/model/user.model';
import { OrganizationService } from 'src/app/component/common-components/organizations/service/organization.service';
import { ORGANIZATION } from 'src/app/model/school.model';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { ApiSchoolsService } from 'src/app/service/api-schools.service';
import { NoopAnimationPlayer } from '@angular/animations';
// for backup/restore setup
import StorageModule from '@ngrx/store';

@Component({
    selector: 'app-school-view',
    templateUrl: './school-view.component.html',
    styleUrls: ['./school-view.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SchoolViewComponent implements OnInit, AfterViewInit {
    @ViewChild(MatAccordion) accordion!: MatAccordion;
    @Input() inOrgId!: number;

    school: School;
    CDSCode: string = '';
    closedDate: string = '';
    county: string = '';
    district: string = '';
    gradeSpan: string = '';
    NCES: string = '';
    region: string = '';
    regionName: string = ''; // fully qualified name
    districtCode: string = '';
    ncesCode: string = '';

    user: User = {};
    partyRoles: PARTYROLE[] = [];
    regions: Region[] = [];
    userIdChanged: boolean = false;
    partyContactMechanisms: PartyContactMechanisms[] = [];
    deletePartyContactMechanisms: PartyContactMechanisms[] = [];
    isEditingPartyContactMechanisms: Event; //boolean = false;

    suffixes: string[] = ['Jr', 'Sr', 'II', 'III', 'IV', 'V', 'VI'];
    isLoading: boolean = false;
    isDone: boolean = false;
    msg: MsgModel = {};
    userIdChangedMsg: MsgModel = {};

    promises: Array<any> = [];

    myControl: any;
    filteredOptions!: Observable<any>;
    private unsubUsername$: Subject<void> = new Subject<void>();

    contactInfoForm!: UntypedFormGroup;

    schoolName: string = '';
    schoolProperty: string = '';
    schoolStatus: string = '';
    mySchoolStatus: SCHOOL_STATUS;
    schoolType: string = '';
    SSID: string = '';

    organizationService: any;
    partyId: any = [{}];
    organizationId!: number;
    myOrganization!: ORGANIZATION;

    partyIdNum!: number;

    // backup components
    chosenSchools: any;
    filterSchoolDistricts: any;

    constructor(
        public dialogRef: MatDialogRef<SchoolViewComponent>,
        @Inject(MAT_DIALOG_DATA) public editData: any,
        organizationService: OrganizationService,
        private dialog: MatDialog,
        private fb: UntypedFormBuilder,
        private userProfileService: UserProfileService,
        private schoolAPIService: ApiSchoolsService,
        private viewContainerRef: ViewContainerRef,
        private renderer: Renderer2
    ) {
        this.organizationService = organizationService;

        this.contactInfoForm = fb.group({
            firstName: ['', [Validators.required]],
            middleInitial: ['', null],
            lastName: ['', [Validators.required]],
            suffix: ['', null],
            workTitle: ['', [Validators.required]],
            workEmail: ['', [Validators.required, Validators.email]],
            username: ['', [Validators.required]]
        });
        this.isLoading = true;
    }

    ngOnInit(): void {
        console.log('getting userprofile');
        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            // console.log("reading this:" + Object.entries(res))
            // console.log("here's the data coming in:" + this.editData)
            // console.log(Object.keys(this.editData));
            // console.log(Object.values(this.editData));
            this.getPartyRoles();
            // console.log("got party roles")
            this.getRegionsByPartyId();
            // console.log("got regions by party id")
        });

        this.fnInit();
    }

    ngAfterViewInit(): void {
        this.dialogRef.afterOpened().subscribe(() => {
            const dialogContainer = this.dialogRef._containerInstance;
            this.renderer.setStyle(dialogContainer, 'overflow', 'hidden');
            
          });
    }

    fnInit() {
        console.log('now calling fnInit');
        console.log('edit data object');
        console.log(this.editData);

        // set school object
        this.schoolAPIService.show(this.editData['ID']).subscribe((res) => {
            console.log('thisSchool: ');
            this.school = res.school;
            console.log(this.school);

            // set school data
            this.region = this.school.REGION; //this.editData['REGION'];
            const regionShell = this.school.REGIONS; //this.editData['REGIONS'];
            this.regionName = regionShell['NAME'] || '';

            const districtShell = this.school.SCHOOL_DISTRICT.DISTRICTS; // this.editData['SCHOOL_DISTRICT'];
            this.districtCode = this.school.SCHOOL_DISTRICT.CODE.toString(); //districtShell['CODE'].toString();
            const ncesShell = this.school.SCHOOL_DISTRICT.NCESDist; //this.editData['NCES'];
            this.ncesCode = this.school.SCHOOL_DISTRICT?.NCESDist.toString() || '';
            this.NCES = this.school.SCHOOL_NCES;

            const districtOrganizationShell = this.school.SCHOOL_DISTRICT.ORGANIZATION.NAME; ////districtShell['ORGANIZATION'];

            var translateCounty = this.school.COUNTy.COUNTY_NAME; //(Object.values(this.editData['COUNTy'])?.toString()).split(',');
            this.county = translateCounty + ' (' + this.school.COUNTy.ID + ')'; // translateCounty[2] + " (" + translateCounty[3] + ")";
            this.district = this.school.DISTRICT; // this.editData['DISTRICT'];
            this.schoolType = this.school.SCHOOL_TYPE?.TYPE; //this.editData['SCHOOL_TYPE_ID'];
            this.SSID = this.school.SSID; // editData['SSID'];
            this.CDSCode = this.school.cdscODE; //this.editData['cdscODE'];
            this.gradeSpan = this.fnFormatGradeSpan(this.school.LOW_GRADES, this.school.HIGH_GRADES);

            var translateSchoolStatus: number; //string[] = [];
            translateSchoolStatus = this.school.SCHOOL_STATUS.SCHOOL_STATUS_TYPES_ID; //(Object.values(this.school.SCHOOL_STATUS.toString()).split(',')); //this.editData['SCHOOL_STATUS'])
            this.schoolStatus = translateSchoolStatus == 1 ? 'Open' : 'Close/Merged'; //translateSchoolStatus[2]

            this.schoolProperty = this.school.SCHOOL_PROPERTY_TYPES?.TYPE;

            this.mySchoolStatus = this.school.SCHOOL_STATUS;
            if (this.mySchoolStatus) {
                if (this.mySchoolStatus.CLOSE_DATE) {
                    this.closedDate = new CleanDatePipe().transform(this.mySchoolStatus.CLOSE_DATE);
                    var cleanDate = new Date(this.closedDate);
                    console.log('closed date from : ' + cleanDate.getTime());
                    if (cleanDate.getTime() == -62135596800000) {
                        // handle invalid date
                        this.closedDate = '';
                    }
                }
            }
            this.schoolName = this.school.NAME; //this.editData['NAME'];

            /*  console.log("incomingData:" + this.region + "," + this.county + "," + this.district
        + "," + this.schoolType + "," + this.SSID
        + "," + this.CDSCode + "," + this.NCES
        + "," + this.gradeSpan + "," + this.schoolStatus
        + "," + this.schoolProperty + "," + this.closedDate
        + "," + this.schoolName
      ); */

            this.isLoading = false;

            // load party data
            if (this.school.ORGANIZATIONS_ID) {
                this.organizationId = this.school.ORGANIZATIONS_ID; //this.editData['ORGANIZATIONS_ID'];

                this.organizationService.show(this.organizationId).subscribe({
                    next: (res: any) => {
                        this.myOrganization = res.organization;
                        //console.log("organization is: " + Object.entries(this.myOrganization));
                        //console.log("party ids are: " + this.myOrganization.PARTIES_ID)
                        this.partyId = this.myOrganization.PARTIES_ID;
                        this.partyIdNum = parseInt(this.partyId);
                        // this.getPartyRoleTypesByCategory({ 'partyRoleCategoryType': 'ORGANIZATION' });
                        // console.log("inbound organization id1 is: " + this.organizationId);
                        // console.log("my organization: " + this.myOrganization.PARTIES_ID);
                    },
                    error: (err: any) => {
                        alert('Error while fetching the records');
                        console.log('error while getting organization data');
                    }
                });
            }
        });
    }

    fnFormatGradeSpan(lowGrades: Grade, highGrades: Grade) {
        let lowGradeDesc: string = '';
        let lowGrade: string = '';

        if (lowGrades) {
            lowGradeDesc = lowGrades.DESCRIPTION ? lowGrades.DESCRIPTION : '';
            lowGrade = lowGrades.GRADES ? lowGrades.GRADES : '';
        }
        let highGradeDesc: string = '';
        let highGrade = '';

        if (highGrades) {
            highGradeDesc = highGrades.DESCRIPTION ? highGrades.DESCRIPTION : '';
            highGrade = highGrades.GRADES ? highGrades.GRADES : '';
        }
        let retString = '';
        let strFirstPart = '';
        let strSecondPart = '';
        if (lowGrade && lowGradeDesc) {
            strFirstPart = lowGradeDesc + '(' + lowGrade + ')';
        }
        if (highGrade && highGradeDesc) {
            strSecondPart = highGradeDesc + '(' + highGrade + ')';
        }
        if (strFirstPart && strSecondPart) {
            retString = strFirstPart + ' to ' + strSecondPart;
        } else {
            if (!strFirstPart) {
                retString = ' to ' + strSecondPart;
            }
            if (!strSecondPart) {
                retString = strFirstPart;
            }
        }
        return retString;
    }
    //edit-contact-mechanisms functions
    getPartyRoles() {
        console.log('getting party roles for user:' + Object.entries(this.user));
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log('got party roles:' + res.partyRoles);
            }
        });
    }

    getRegionsByPartyId() {
        console.log('getting regions by party id:');
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                console.log(Object.entries(res.regions));
                this.regions = res.regions;
            }
        });
    }

    editRecord() {
        const dialogRef = this.dialog.open(EditSchoolComponent, {
            width: '90%',
            height: '90%',
            data: this.editData,
            viewContainerRef: this.viewContainerRef
        });
        dialogRef.afterClosed().subscribe((result) => {
            console.log('passing result');
            console.log(result);
            this.fnInit();
        });
    }

    closeRecord() {
        this.dialogRef.close(this.school);
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    this.contactInfoForm.patchValue({
                        firstName: this.user.PERSON?.FIRST_NAME,
                        middleInitial: this.user.PERSON?.MIDDLE_INITIAL,
                        lastName: this.user.PERSON?.LAST_NAME,
                        suffix: this.user.PERSON?.SUFFIX,
                        workTitle: this.user.WORK_TITLE,
                        workEmail: this.user.EMAIL_ADDRESS,
                        username: this.user.USER_ID
                    });

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }
}
